import {Images} from '~data'
const featureSectionData = {
    tabWidget1: [
        {
            icon:Images.projectManagement.featureTwoIcon7,
            iconBackground:"#ff8d52",
            title:"Document Sharing",
            text:"Quickly send any document to anyone, even if they don’t have a DocPile account.",
        },
        {
            icon:Images.projectManagement.featureTwoIcon8,
            iconBackground:"#0065FF",
            title:"Document Tracking",
            text:"Manage tasks, track document updates and stay in sync with your teams and clients.",
        },
        {
            icon:Images.projectManagement.featureTwoIcon9,
            iconBackground:"#36B37E",
            title:"Document Editing",
            text:"Colloborate and edit PDF and images using our powerful online tools.",
        },
    ],

    tabWidget2: [
        {
            icon:Images.projectManagement.featureTwoIcon4,
            iconBackground:"#ff8d52",
            title:"Document Invite",
            text:"Effortlessly collect documents and information from clients in a secure way.",
        },
        {
            icon:Images.projectManagement.featureTwoIcon10,
            iconBackground:"#0065FF",
            title:"Document Storage",
            text:"Documents are stored securely in a end-to-end encrypted format.",
        },
        {
            icon:Images.projectManagement.featureTwoIcon6,
            iconBackground:"#36B37E",
            title:"Document Sign",
            text:"Seamlessly send electronic documents for digital signatures.",
        },
    ],
    
    tabWidget3: [
        {
            icon:Images.projectManagement.featureTwoIcon11,
            iconBackground:"#ff8d52",
            title:"Document Extraction",
            text:"Parse and extract information from documents in human readable format.",
        },
        {
            icon: Images.projectManagement.featureTwoIcon3,
            iconBackground:"#0065FF",
            title:"Document Verification",
            text:"Documents are verified against credible third-party sources to avoid data inconsistencies and mitigate risks.",
        },
        {
            icon:Images.projectManagement.featureTwoIcon5,
            iconBackground:"#36B37E",
            title:"Document Insights",
            text:"Summarize relevant information and aggregate data into reports to inform and expedite decision making.",
        },
    ],
}

export default featureSectionData;

  